import { MapDataItem } from '@bpd-library/types';
import {
    ExtendedApartmentBuilding,
    ExtendedAreaProject,
    ExtendedConstructionNumber,
    ExtendedDistrict,
    ExtendedProjectPhase,
    ExtendedPropertyType,
} from '@bpd-library/utilities';

const getExtendedAreaMapData = ({
    constructionNumbers,
    propertyTypes,
    projectPhases,
    apartmentBuildings,
    districts,
    areaProject,
}: {
    constructionNumbers?: ExtendedConstructionNumber[];
    propertyTypes?: ExtendedPropertyType[];
    projectPhases?: ExtendedProjectPhase[];
    apartmentBuildings?: ExtendedApartmentBuilding[];
    districts?: ExtendedDistrict[];
    areaProject?: ExtendedAreaProject;
}): MapDataItem[] => {
    const extractMapData = (arr: { mapDataItems?: MapDataItem[] }[]) =>
        arr
            .filter(({ mapDataItems }) => !!mapDataItems?.length)
            .map(({ mapDataItems }) => mapDataItems!)
            .reduce<MapDataItem[]>((mapData, items) => [...mapData, ...items], []);

    const mapData: MapDataItem[] = [];

    if (constructionNumbers) mapData.push(...extractMapData(constructionNumbers));
    if (propertyTypes) mapData.push(...extractMapData(propertyTypes));
    if (projectPhases) mapData.push(...extractMapData(projectPhases));
    if (apartmentBuildings) mapData.push(...extractMapData(apartmentBuildings));
    if (districts) mapData.push(...extractMapData(districts));
    if (areaProject) mapData.push(...extractMapData([areaProject]));

    return mapData;
};

export default getExtendedAreaMapData;
